import * as S from './styles'
import Table from '../Table'

import { dateFromString, timeFromString } from '../DadosCadastroPF/masks'
import { capitalizePhrase, convertDecimalCurrency } from '../../utils/utils'

import GimbaLogo from '../../assets/img/logo-gimba.jpg'
import { getPedidoStatusColor } from '../FichaPedido/utils'
import { getStatusCotacao, getStatusNegociacao } from '../OperationCard/utils'
import { changePagamentoMessage } from '../CotacaoDetalhe/utils'

const OperationCardPrint = ({ type, item }) => {
  const filiais = (input) => {
    const ids = new Set()

    return input
      ?.map((e) => ({ filial: e.Filial, id: e.IdFilial }))
      .filter((e) => {
        if (ids.has(e.id)) {
          return false
        }

        ids.add(e.id)
        return true
      })
  }

  return (
    <S.Card>
      <S.CardHeader style={{ marginBottom: 12 }}>
        <div className="print-header">
          <img src={GimbaLogo} alt="" style={{ width: 140, marginBottom: 8 }} />
          <S.CardNumber class="negociacoes-card-number">
            {type === 'c' ? 'Cotação' : 'Negociação'} Nº {item?.Id}
          </S.CardNumber>
        </div>

        <S.Column style={{ padding: 0 }}>
          {type === 'c' ? (
            <>
              <S.CardDescription>
                <strong>Validade: </strong>
                {dateFromString(item.DataValidade)} às{' '}
                {timeFromString(item.DataValidade)}
                {item.Expirado && ' - Vencida'}
              </S.CardDescription>
              <S.CardDescription>
                <strong>Data: </strong>
                {dateFromString(item.DataRequisicao)}
                <strong> Horário: </strong>{' '}
                {timeFromString(item.DataRequisicao)}
              </S.CardDescription>
            </>
          ) : (
            <S.CardDescription>
              <strong>Data: </strong>
              {dateFromString(item.DataRequisicao)}
              <strong> Horário: </strong> {timeFromString(item.DataRequisicao)}
            </S.CardDescription>
          )}

          {type === 'n' && (
            <S.CardDescription>
              <strong>Desconto: </strong>
              {convertDecimalCurrency(item?.ValorDesconto)}
            </S.CardDescription>
          )}

          <S.CardDescription>
            <strong>Valor Total: </strong>
            {convertDecimalCurrency(item?.ValorTotal)}
          </S.CardDescription>
        </S.Column>
      </S.CardHeader>

      <S.CardContent show={true}>
        <S.CardContentWrapper>
          <S.Details>
            <S.DetailsWrapper className="card">
              {type === 'c' ? (
                <>
                  <h3>Detalhes da Cotação</h3>

                  <p>
                    <strong>Cotação nº: </strong> {item?.Id}
                  </p>
                  <p>
                    <strong>Validade: </strong>{' '}
                    {dateFromString(item?.DataValidade)} às{' '}
                    {timeFromString(item?.DataValidade)}
                    {item?.Expirado && ' - Vencida'}
                  </p>
                  <p>
                    <strong>Data: </strong>{' '}
                    {dateFromString(item?.DataRequisicao)} às{' '}
                    {timeFromString(item?.DataRequisicao)}
                  </p>

                  <p className="status">
                    <strong>Status Atual: </strong>{' '}
                    <S.Tag
                      color={getPedidoStatusColor(item?.DescricaoSituacao)}
                      type={getStatusCotacao(item)}
                    >
                      {getStatusCotacao(item)}
                    </S.Tag>
                  </p>

                  <p>
                    <strong>Produtos: </strong>{' '}
                    {item?.ValorProdutos === 0
                      ? convertDecimalCurrency(item?.ValorTotal)
                      : convertDecimalCurrency(item?.ValorProdutos)}
                  </p>
                  {!item.PossuiIPI ? null : (
                    <p>
                      <strong>IPI: </strong>{' '}
                      {convertDecimalCurrency(item?.ValorTotalIPI)}
                    </p>
                  )}

                  <p>
                    <strong>Frete: </strong>{' '}
                    {item?.ValorFrete === 0
                      ? 'Grátis'
                      : convertDecimalCurrency(item?.ValorFrete)}
                  </p>

                  {item?.ValorAcrescimoFinanceiro === 0 ? null : (
                    <p>
                      <strong>Acréscimo Financeiro: </strong>{' '}
                      {convertDecimalCurrency(item?.ValorAcrescimoFinanceiro)}
                    </p>
                  )}

                  {item?.ValorSubstituicaoTributaria === 0 ? null : (
                    <p>
                      <strong>ICMS-ST: </strong>{' '}
                      {convertDecimalCurrency(
                        item?.ValorSubstituicaoTributaria
                      )}
                    </p>
                  )}

                  {item?.DetalhePagamento?.DescontoFormaPagamento ===
                  0 ? null : (
                    <p>
                      <strong>Desconto Pagamento: </strong>{' '}
                      {convertDecimalCurrency(
                        item?.DetalhePagamento?.DescontoFormaPagamento
                      )}
                    </p>
                  )}

                  {item?.ValorDescontoGimplus === 0 ? null : (
                    <p>
                      <strong>Desconto Gimplus: </strong>{' '}
                      {convertDecimalCurrency(item?.ValorDescontoGimplus)}
                    </p>
                  )}

                  {item?.CupomDesconto !== null && (
                    <p>
                      <strong>Cupom Desconto: </strong>{' '}
                      {convertDecimalCurrency(item?.ValorCupomDesconto)}
                    </p>
                  )}

                  <p>
                    <strong>Valor Total: </strong>{' '}
                    {convertDecimalCurrency(item?.ValorTotal)}
                  </p>
                </>
              ) : (
                <>
                  <h3>Detalhes da Negociação</h3>

                  <p>
                    <strong>Negociação nº: </strong> {item?.Id}
                  </p>
                  <p>
                    <strong>Validade: </strong>{' '}
                    {dateFromString(item?.DataValidade)} às{' '}
                    {timeFromString(item?.DataValidade)}
                    {item?.Expirado && ' - Vencida'}
                  </p>
                  <p>
                    <strong>Data: </strong>{' '}
                    {dateFromString(item?.DataRequisicao)} às{' '}
                    {timeFromString(item?.DataRequisicao)}
                  </p>

                  <p className="status">
                    <strong>Status Atual: </strong>{' '}
                    <S.Tag
                      color={getPedidoStatusColor(item?.DescricaoSituacao)}
                      type={getStatusNegociacao(item)}
                    >
                      {getStatusNegociacao(item)}
                    </S.Tag>
                  </p>

                  <p>
                    <strong>Produtos: </strong>{' '}
                    {item?.ValorProdutos === 0
                      ? convertDecimalCurrency(item?.ValorTotal)
                      : convertDecimalCurrency(item?.ValorProdutos)}
                  </p>
                  {!item.PossuiIPI ? null : (
                    <p>
                      <strong>IPI: </strong>{' '}
                      {convertDecimalCurrency(item?.ValorTotalIPI)}
                    </p>
                  )}
                  <p>
                    <strong>Frete: </strong>{' '}
                    {item?.ValorFrete === 0
                      ? 'Grátis'
                      : convertDecimalCurrency(item?.ValorFrete)}
                  </p>

                  {item?.ValorAcrescimoFinanceiro === 0 ? null : (
                    <p>
                      <strong>Acréscimo Financeiro: </strong>{' '}
                      {convertDecimalCurrency(item?.ValorAcrescimoFinanceiro)}
                    </p>
                  )}

                  {item?.ValorSubstituicaoTributaria === 0 ? null : (
                    <p>
                      <strong>ICMS-ST: </strong>{' '}
                      {convertDecimalCurrency(
                        item?.ValorSubstituicaoTributaria
                      )}
                    </p>
                  )}

                  {item?.DetalhePagamento?.DescontoFormaPagamento ===
                  0 ? null : (
                    <p>
                      <strong>Desconto Pagamento: </strong>{' '}
                      {convertDecimalCurrency(
                        item?.DetalhePagamento?.DescontoFormaPagamento
                      )}
                    </p>
                  )}

                  {item?.ValorDescontoGimplus === 0 ? null : (
                    <p>
                      <strong>Desconto Gimplus: </strong>{' '}
                      {convertDecimalCurrency(item?.ValorDescontoGimplus)}
                    </p>
                  )}

                  {item?.CupomDesconto !== null && (
                    <p>
                      <strong>Cupom Desconto: </strong>{' '}
                      {convertDecimalCurrency(item?.ValorCupomDesconto)}
                    </p>
                  )}

                  <p>
                    <strong>Valor Total: </strong>{' '}
                    {convertDecimalCurrency(item?.ValorTotal)}
                  </p>
                </>
              )}
            </S.DetailsWrapper>

            <S.AddressPaymentWrapper>
              <S.AddressPaymentItem className="card">
                <h3>Detalhes do Pagamento</h3>

                <p>
                  <strong>Forma de Pagamento: </strong>{' '}
                  {item?.DetalhePagamento?.DescricaoFormaPagamento}
                </p>

                <p>
                  <strong>Condição de Pagamento: </strong>{' '}
                  {changePagamentoMessage(item)}
                </p>
              </S.AddressPaymentItem>

              <S.AddressPaymentItem className="card">
                <h3>Detalhes da Entrega</h3>

                <p>
                  <strong>Endereço de Entrega: </strong>
                  {capitalizePhrase(item?.EnderecoEntrega?.Endereco)},{' '}
                  {item?.EnderecoEntrega?.Numero} -{' '}
                  {capitalizePhrase(item?.EnderecoEntrega?.Bairro)} -{' '}
                  {capitalizePhrase(item?.EnderecoEntrega?.Cidade)}/
                  {item?.EnderecoEntrega?.UF} -{' '}
                  {item?.EnderecoEntrega?.CEP.replace(
                    /^([\d]{2})*([\d]{3})-*([\d]{3})/,
                    '$1$2-$3'
                  )}
                </p>

                <p>
                  <strong>Endereço de Faturamento: </strong>
                  {capitalizePhrase(item?.EnderecoFaturamento?.Endereco)},{' '}
                  {item?.EnderecoFaturamento?.Numero} -{' '}
                  {capitalizePhrase(item?.EnderecoFaturamento?.Bairro)} -{' '}
                  {capitalizePhrase(item?.EnderecoFaturamento?.Cidade)}/
                  {item?.EnderecoFaturamento?.UF} -{' '}
                  {item?.EnderecoFaturamento?.CEP.replace(
                    /^([\d]{2})*([\d]{3})-*([\d]{3})/,
                    '$1$2-$3'
                  )}
                </p>
              </S.AddressPaymentItem>
            </S.AddressPaymentWrapper>
          </S.Details>

          <Table products={item?.Itens} type={type} filiais={filiais} print />
        </S.CardContentWrapper>
      </S.CardContent>
    </S.Card>
  )
}

export default OperationCardPrint
